export type PropagateToWorkersField =
  | 'actualMiddlewareFile'
  | 'actualInstrumentationHookFile'
  | 'reloadMatchers'
  | 'loadEnvConfig'
  | 'appPathRoutes'
  | 'middleware'
  | 'renderOpts'
